<template>
    <rkm-area
        no-margin-top
        title="Identificação"
    >
        <rkm-row>
            <rkm-col cols="2">
                <Item
                    :get-value="() => item.data"
                    label="Data"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.horario"
                    label="Horário"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.atendimentoTipo ? item.atendimentoTipo.descricao : null"
                    label="Tipo de atendimento"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.local ? item.local.descricao : null"
                    label="Local de atendimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <Item
                    :get-value="() => item.centroCusto.unidade ? item.centroCusto.unidade.nomeFantasia : null"
                    label="Unidade"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>
